// Marca de "abierto desde el acceso directo .bat" (modo caja cerrada).
// El .bat abre /pos-pin?kiosk=1 y la marca queda en sessionStorage, así sobrevive
// a los saltos a /pos pero no contamina otras pestañas ni sesiones normales.
const KEY = "aipos_kiosk_shell";

export function initKioskShell() {
  try {
    const p = new URLSearchParams(window.location.search);
    if (p.get("kiosk") === "1") sessionStorage.setItem(KEY, "1");
  } catch (_) { /* navegador sin sessionStorage */ }
}

export function isKioskShell() {
  try { return sessionStorage.getItem(KEY) === "1"; } catch (_) { return false; }
}

/** Cierra la ventana del punto de venta (y la sesión) cuando se abrió desde el .bat. */
export function closeKioskWindow() {
  try {
    localStorage.removeItem("aipos_token");
    localStorage.removeItem("aipos_refresh");
    localStorage.removeItem("aipos_user");
    sessionStorage.removeItem("pos_operator");
  } catch (_) {}
  try { window.close(); } catch (_) {}
  return new Promise((resolve) => setTimeout(() => resolve(!window.closed), 400));
}
